import {Link} from 'react-router-dom';
import headerImage from '../images/Dwi_Pada_rope_crop.png';

const MainHeader = () => {
  return (
    <header className="main__header">
      <div className="main__header-container">
        <div className="header__container-bg">
          <img src={headerImage} alt="Dwi Pada Viparita Dandasana" />
        </div>
        <div className="main__header-content">
          <p className="main__header-eyebrow">Iyengar Yoga · St Petersburg, FL</p>
          <h1>What you learn in class<br/>becomes <em>your practice.</em></h1>
          <p className="main__header-sub">Precise, safe, and deeply transformative.<br/>Classes for all levels — beginners welcome.</p>
          <a href="#faqs" onClick={(e) => { e.preventDefault(); document.querySelector(".calendar-embed")?.scrollIntoView({ behavior: "smooth" }); }} className="btn lg">Book a class</a>
        </div>
      </div>
    </header>
  )
}

export default MainHeader
